import React, { useEffect, useRef } from "react";

import CountUp from "@/components/reactbits/CountUp";

type Props = {
  value: number;
  decimals?: number;
  prefix?: string;
  suffix?: string;
  /** Show + / − in front (P&L, R). */
  signed?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

/** A live number that counts to its new value (React Bits CountUp), with sign / unit around it. */
export function AnimatedNumber({ value, decimals = 0, prefix = "", suffix = "", signed, className, style }: Props) {
  const prev = useRef(0);
  const from = prev.current;
  useEffect(() => {
    prev.current = Math.abs(value);
  }, [value]);
  const abs = Number(Math.abs(value).toFixed(decimals));
  const sign = signed ? (value > 0 ? "+" : value < 0 ? "−" : "") : value < 0 ? "−" : "";
  return (
    <span className={className} style={style}>
      {sign}
      {prefix}
      <CountUp from={from} to={abs} decimals={decimals} duration={0.8} separator="," className="tabular-nums" />
      {suffix}
    </span>
  );
}
